<p-tabs value="{{activeTabIndex}}" *ngIf="!isOpened">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
    <p-tab (click)="handleTabChange(2)" value="2" *ngIf="swModuloCompra">
      Consulta Pedidos Pendientes</p-tab>
    <app-custom-button class="widthBtns" [title]="'Nuevo Registro'" [label]="'Nuevo'" [severity]="'success'"
      [icon]="'pi pi-plus'" [width]="'5.5rem'" [variant]="undefined"
      (onClick)="createNewRegister()"></app-custom-button>
  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'inventory-output'"
        (onRecoverData)="getInventoryOutputsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader" [data]="detailData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'inventory-output'"
        (onRecoverData)="getDetailsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()" (onAction)="onAction($event)">
      </app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="pendingOrderHeader"
        [data]="pendingOrderData" [previousFilters]="filters" [filterPersistentKey]="'inventory-output'"
        (onRecoverData)="getPendingOrdersWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()">
      </app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>